// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".medi-club-logo-inline__image--multiline[data-v-549a8b7b]{display:inline;height:1em}.medi-club-logo-inline__image--oneline[data-v-549a8b7b]{display:none;height:.7em}@media(min-width:1024px){.medi-club-logo-inline__image--multiline[data-v-549a8b7b]{display:none}.medi-club-logo-inline__image--oneline[data-v-549a8b7b]{display:inline}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
